// modifer: styles/jss/nextjs-material-kit-pro/pages/componentsSections/basicsStyle
import { section, container, title } from 'styles/jss/original/base';
import customCheckboxRadioSwitch from 'styles/jss/original/components/common/ui/customCheckboxRadioSwitchStyle';
import customSelectStyle from 'styles/jss/original/components/common/ui/customSelectStyle';

const styles = {
  section: {
    ...section,
    padding: '20px 0 40px',
    '@media (max-width: 992px)': {
      padding: '20px 0 30px'
    },
    '@media (max-width: 640px)': {
      padding: '10px 0 20px'
    }
  },
  container,
  ...customSelectStyle,
  ...customCheckboxRadioSwitch,
  title: {
    ...title,
    marginTop: '0'
  },
  attention: {
    margin: '10px 0 20px'
  },
  checkRoot: {
    padding: '8px 14px'
  }
};

export default styles;
